/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseBusinessCategory,
    PressReleaseBusinessCategoryFromJSON,
    PressReleaseBusinessCategoryFromJSONTyped,
    PressReleaseBusinessCategoryToJSON,
} from './PressReleaseBusinessCategory';
import {
    PressReleaseLocationCategory,
    PressReleaseLocationCategoryFromJSON,
    PressReleaseLocationCategoryFromJSONTyped,
    PressReleaseLocationCategoryToJSON,
} from './PressReleaseLocationCategory';
import {
    PressReleasePrefecture,
    PressReleasePrefectureFromJSON,
    PressReleasePrefectureFromJSONTyped,
    PressReleasePrefectureToJSON,
} from './PressReleasePrefecture';
import {
    PressReleaseTestEmailAddress,
    PressReleaseTestEmailAddressFromJSON,
    PressReleaseTestEmailAddressFromJSONTyped,
    PressReleaseTestEmailAddressToJSON,
} from './PressReleaseTestEmailAddress';
import {
    PressReleaseType,
    PressReleaseTypeFromJSON,
    PressReleaseTypeFromJSONTyped,
    PressReleaseTypeToJSON,
} from './PressReleaseType';

/**
 * プレスリリースエディタのマスターデータ
 * @export
 * @interface PressReleaseEditorMaster
 */
export interface PressReleaseEditorMaster {
    /**
     * 編集可能な権限かどうか
     * @type {boolean}
     * @memberof PressReleaseEditorMaster
     */
    isAdmin: boolean;
    /**
     * 権限継承モードかどうか
     * @type {boolean}
     * @memberof PressReleaseEditorMaster
     */
    isSystemAdminMode?: boolean;
    /**
     * 編集開始タイムスタンプ
     * @type {number}
     * @memberof PressReleaseEditorMaster
     */
    editStartedAt: number;
    /**
     * プレスリリース種類マスタ
     * @type {Array<PressReleaseType>}
     * @memberof PressReleaseEditorMaster
     */
    releaseTypes: Array<PressReleaseType>;
    /**
     * ビジネスカテゴリマスタ
     * @type {Array<PressReleaseBusinessCategory>}
     * @memberof PressReleaseEditorMaster
     */
    businessCategories: Array<PressReleaseBusinessCategory>;
    /**
     * 都道府県マスタ
     * @type {Array<PressReleasePrefecture>}
     * @memberof PressReleaseEditorMaster
     */
    prefectures: Array<PressReleasePrefecture>;
    /**
     * 位置情報カテゴリマスタ
     * @type {Array<PressReleaseLocationCategory>}
     * @memberof PressReleaseEditorMaster
     */
    locationCategories: Array<PressReleaseLocationCategory>;
    /**
     * テストメール送信先一覧
     * @type {Array<PressReleaseTestEmailAddress>}
     * @memberof PressReleaseEditorMaster
     */
    testEmailAddressList: Array<PressReleaseTestEmailAddress>;
    /**
     * クリッピングアカウントを作成済みかどうか
     * @type {boolean}
     * @memberof PressReleaseEditorMaster
     */
    isClippingRegistered: boolean;
}

export function PressReleaseEditorMasterFromJSON(json: any): PressReleaseEditorMaster {
    return PressReleaseEditorMasterFromJSONTyped(json, false);
}

export function PressReleaseEditorMasterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseEditorMaster {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAdmin': json['is_admin'],
        'isSystemAdminMode': !exists(json, 'is_system_admin_mode') ? undefined : json['is_system_admin_mode'],
        'editStartedAt': json['edit_started_at'],
        'releaseTypes': ((json['release_types'] as Array<any>).map(PressReleaseTypeFromJSON)),
        'businessCategories': ((json['business_categories'] as Array<any>).map(PressReleaseBusinessCategoryFromJSON)),
        'prefectures': ((json['prefectures'] as Array<any>).map(PressReleasePrefectureFromJSON)),
        'locationCategories': ((json['location_categories'] as Array<any>).map(PressReleaseLocationCategoryFromJSON)),
        'testEmailAddressList': ((json['test_email_address_list'] as Array<any>).map(PressReleaseTestEmailAddressFromJSON)),
        'isClippingRegistered': json['is_clipping_registered'],
    };
}

export function PressReleaseEditorMasterToJSON(value?: PressReleaseEditorMaster | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_admin': value.isAdmin,
        'is_system_admin_mode': value.isSystemAdminMode,
        'edit_started_at': value.editStartedAt,
        'release_types': ((value.releaseTypes as Array<any>).map(PressReleaseTypeToJSON)),
        'business_categories': ((value.businessCategories as Array<any>).map(PressReleaseBusinessCategoryToJSON)),
        'prefectures': ((value.prefectures as Array<any>).map(PressReleasePrefectureToJSON)),
        'location_categories': ((value.locationCategories as Array<any>).map(PressReleaseLocationCategoryToJSON)),
        'test_email_address_list': ((value.testEmailAddressList as Array<any>).map(PressReleaseTestEmailAddressToJSON)),
        'is_clipping_registered': value.isClippingRegistered,
    };
}

